module.exports = __webpack_public_path__ + "static/media/euro.a2ecb152.svg";